export interface UmpirePushNotificationTarget {
  type: string;

  title: string | null;

  value: string | null;

  id: string;

  client_id: string;
}
